export default "/_next/static/videos/band-white-horizontal.mp4";